import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { isNil } from "ramda";

import FacePresenter from "presenters/FacePresenter";
import ResponsiveImage from "components/ResponsiveImage/ResponsiveImage";

import useStyles from "./useStyles";

const DisplayFace = (props) => {
  const classes = useStyles();
  const { face, onClick, clickable } = props;
  const asset = FacePresenter.asset(face);

  return (
    <div className={classes.root}>
      <ResponsiveImage
        draggable="false"
        src={asset}
        onClick={onClick}
        alt={!isNil(face?.person) ? "Person" : "Face"}
        role="presentation"
        className={clsx(classes.personHead, { [classes.clickable]: clickable && !isNil(onClick) })}
        width={86}
        widthMobile={56}
      />
    </div>
  );
};

DisplayFace.propTypes = {
  face: FacePresenter.shape(),
  onClick: PropTypes.func,
  clickable: PropTypes.bool,
};

export default DisplayFace;
